var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrow = function SvgArrow(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6517 6.21785C13.6517 4.42404 15.799 3.50216 17.0995 4.73764L25.9056 13.1034C26.7529 13.9084 26.7529 15.2589 25.9056 16.0639L17.0995 24.4297C15.799 25.6651 13.6517 24.7433 13.6517 22.9495V19.5476C9.18499 19.6072 6.89875 20.1337 5.5377 20.9368C4.20618 21.7225 3.65671 22.8215 2.79494 24.5453L2.76761 24.6C2.58613 24.9629 2.1789 25.1535 1.78395 25.0602C1.389 24.967 1.10999 24.6145 1.10999 24.2087C1.10999 19.3306 1.72891 15.6606 3.74957 13.212C5.76787 10.7662 8.99957 9.7455 13.6517 9.63542V6.21785Z",
    fill: "currentColor"
  })));
};
export default SvgArrow;